import Vue from "vue";
/* https://www.npmjs.com/package/v-tooltip */
import VTooltip from "v-tooltip";
import "./tooltip.less";

/* Tooltip can will be registered as directive 'v-tooltip'. */
Vue.use(VTooltip);
